import {
  ChangeDetectionStrategy,
  Component,
  input,
  inject,
} from '@angular/core';
import { ExportTaxRatesValuesService } from '../../services/export-tax-rates-values.service';
import { ModalService } from '@shared/services';
import { UtilityService } from '@shared/services/utility.service';
import { FileResponse } from 'src/app/web-api-client';
import { HttpStatusCode } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';
import moment from 'moment';

@Component({
  standalone: false,
  selector: 'gstar-export-tax-rates-values-modal',
  templateUrl: './export-tax-rates-values-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [ExportTaxRatesValuesService],
})
export class ExportTaxRatesValuesModalComponent {
  private translation = inject(TranslateService);
  private readonly exportTaxRatesValuesService = inject(
    ExportTaxRatesValuesService
  );
  private readonly modalService = inject(ModalService);
  private readonly utility = inject(UtilityService);

  modalId = input.required<string>();

  confirm(): void {
    this.exportTaxRatesValuesService
      .exportTaxRatesValuesToExcel()
      .subscribe(({ data, fileName, status }: FileResponse) => {
        if (status === HttpStatusCode.Ok) {
          const defaultName = this.translation.instant(
            'admin.dashboard.fileNameDefault',
            { date: moment().format('MM-DD-YYYY') }
          );
          this.utility.download(fileName ?? defaultName, data);
        }
        this.modalService.close(this.modalId());
      });
  }

  closeHandler(): void {
    this.modalService.close(this.modalId());
  }
}
